import React, {useContext} from 'react';
import {t} from 'react-switch-lang';
import {capitalizeFirstLetter} from '../../../utils/helpers';
import './PageTitle.scss';

const PageTitle = ({title}) => {
  // const userContext = useContext(UserData);

  const setTitle = () => {
    let text = '';
    switch (title) {
      case 'locationPageTitle':
        text = `${t(`sidebar.${window.location.pathname.split('/').pop()}`)}`;
        break;
      case 'fromUserData':
        // const pageTitle = userContext.pageTitle.title;
        // text = `${pageTitle}`;
        break;
      case 'addRegistry':
        text = `${t(
          `registry.${window.location.pathname.split('/')[2]}.addTitle`
        )}`;
        break;
      default:
        text = `${t(`sidebar.${title}`)}`;
        break;
    }
    return capitalizeFirstLetter(text);
  };

  return <div className="curr d-block title-nav">{setTitle()}</div>;
};

export default PageTitle;
